import type {z} from "zod";
import {OpenExpedientCustomerOfferFromTemplateBody} from "@project/sdk/sales/zod";

export const openExpedientCustomerOfferFromTemplateFormSchema =
  OpenExpedientCustomerOfferFromTemplateBody.strict();
export type OpenExpedientCustomerOfferFromTemplateFormPayload = z.output<
  typeof openExpedientCustomerOfferFromTemplateFormSchema
>;
export const draftOpenExpedientCustomerOfferFromTemplateFormSchema =
  openExpedientCustomerOfferFromTemplateFormSchema.partial();
export type DraftOpenExpedientCustomerOfferFromTemplateFormPayload = z.output<
  typeof draftOpenExpedientCustomerOfferFromTemplateFormSchema
>;
